import { SpacingValues } from "@/lib/utils/SpacingValues";
import { ZIndex } from "@/lib/utils/ZIndexEnum";
import { Box, Spacing } from "@stenajs-webui/core";
import { MediumIcon } from "@stenajs-webui/elements";
import {
  PageHeader as NewPageHeader,
  PageHeading,
} from "@stenajs-webui/panels";
import { cssColor } from "@stenajs-webui/theme";
import { Property } from "csstype";
import * as React from "react";
import { ReactNode } from "react";
interface Props {
  title: ReactNode;
  breadcrumbs?: ReactNode;
  loading?: boolean;
  contentUnder?: ReactNode;
  contentLeft?: ReactNode;
  contentRight?: ReactNode;
  tabs?: ReactNode;
  backButton?: boolean;
  infoRow?: ReactNode;
  sticky?: boolean;
  zIndex?: Property.ZIndex;
  offsetTop?: number;
  offsetLeft?: number;
  width?: Property.Width;
  icon?: MediumIcon;
  children?: React.ReactNode;
}

export const PageHeader: React.FC<Props> = ({
  breadcrumbs,
  tabs,
  title,
  contentUnder,
  contentRight,
  contentLeft,
  sticky,
  zIndex,
  offsetTop,
  offsetLeft,
  width,
  icon,
  children,
}) => {
  return (
    <>
      <Box
        width={width}
        left={offsetLeft ?? undefined}
        background={cssColor("--lhds-color-ui-50")}
        top={offsetTop ?? undefined}
        position={sticky ? "sticky" : undefined}
        zIndex={zIndex ? zIndex : ZIndex.lowest}
      >
        <NewPageHeader
          renderPageHeading={() => (
            <PageHeading
              icon={icon}
              heading={title as any}
              contentRight={<>{contentRight}</>}
              contentLeft={contentLeft}
            />
          )}
          renderTabs={tabs ? () => tabs : undefined}
          renderBreadCrumbs={breadcrumbs ? () => breadcrumbs : undefined}
        >
          {children}
        </NewPageHeader>
        {contentUnder}
      </Box>
      <Spacing num={SpacingValues.TWELVE} />
    </>
  );
};
